const { AderantAzureStorageError } = require('./errors');

/**
 * Parses a connection string and returns the accountKey and accountName from the connection string.
 * @param {string} connectionString The Azure Storage connection string to be parsed.
 * @returns {AzureConnectionAccountDetails} An object containing the accountKey and accountName
 */
const getAccountDetailsFromConnectionString = (connectionString) => {
    if(typeof connectionString !== 'string') throw new AderantAzureStorageError(`The connection string cannot be null or undefined and must be a string.`);
    if(!connectionString || !connectionString.trim()) throw new AderantAzureStorageError('The connection string is null, empty or whitespace.');
    const connectionStringParts = connectionString.split(';');
    let accountKeyPair = connectionStringParts.find(x => x.indexOf('AccountKey') == 0);
    let accountNamePair = connectionStringParts.find(x => x.indexOf('AccountName') == 0);
    if(!accountKeyPair || !accountNamePair) throw new AderantAzureStorageError('The connection string does not contain the account key or account name.');
    return {
        accountKey: accountKeyPair.replace('AccountKey=', ''),
        accountName: accountNamePair.replace('AccountName=','')
    };
}

module.exports = {getAccountDetailsFromConnectionString}